<template>
    <div style="margin-bottom:30px;padding-top:50px;">
      <button class="btn btn-light note" v-for="note in notes" v-bind:key="note.name" @click=" () => noteClicked(note.frequency, note.solfege)">
        {{ note.solfege }}
      </button>
    </div>
</template>

<script>
export default {
  name: 'Scale',
  props: {
    notes: Array,
    noteClicked: Function
  }
}
</script>

<style scoped>
 .note {
   margin-right: 1rem;
   border-radius: 10%;
 }
</style>
